export { revalidateCommunity } from 'next-flight-server-reference-proxy-loader?id=400f1a45f80e86a09ce36373a607df2c1b0ef4897e&name=revalidateCommunity!'